<template>
    <i style="min-width: 15px;min-height: 15px;width: 15px;height: 15px;"  v-html="iconSvg(name)" :class="`size-${size} ${iconClass}`"/>

<!--  <i style="min-width: 20px;min-height: 20px;width: 20px;height: 20px;" v-html="iconSvg(name)" :class="`size-${size} ${iconClass}`"/>-->
</template>

<script>
    import feather from 'feather-icons'

    export default {
        name: 'IconHome',
        props: {
            name: {
                type: String,
                required: true
            },
            size: {
                type: String|Number,
                default: 18
            },
            iconClass: {
                type: String,
                default: ''
            }
        },
        methods: {
            iconSvg(icon) {
                return feather.icons[icon].toSvg()
            }
        }
    }
</script>